import type { SpreadReadingProfile } from "../types";

export const psychologicalLifeProfileReadingProfile: SpreadReadingProfile = {
  spreadId: "spread_psychological_life_profile",
  sections: [
    {
      id: "mainMeaning",
      title: "Основной смысл",
      source: { type: "keywords" },
    },
    {
      id: "psychology",
      title: "Психологический аспект",
      source: { type: "psychology" },
    },
    {
      id: "questionContext",
      title: "В контексте вопроса",
      source: { type: "uprightByQuestionContext" },
    },
  ],
};

